<!--
 * @Description: 
--> 
<!--
 * @Description: 账号注册
--> 
<template>
  <div class="register">
    <van-nav-bar
      :title="$route.meta.title"
      fixed
      >
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <van-form @submit="onSubmit">
      <!-- <van-field
        required
        v-model="username"
        label="用户姓名"
        placeholder="请输入用户姓名"
        :rules="[{ required: true, message: '请输入用户姓名' }]"
      >
      </van-field> -->
      <van-field
        required
        v-model="pwd"
        type="password"
        name="密码"
        label="密码"
        placeholder="密码"
        :rules="[{ required: true, message: '请填写密码' }]"
      />
      <van-field
        required
        v-model="confirmPwd"
        type="password"
        name="确认密码"
        label="确认密码"
        placeholder="确认密码"
        :rules="[{ required: true, message: '请填写确认密码' }]"
      />
      <van-field
        required
        v-model="phone"
        label="手机号码"
        placeholder="请输入手机号码"
        :rules="[{ pattern: $pattern, message: '请输入正确格式' }]"
      >
      </van-field>
      <van-field
        required
        v-model="smscode"
        label="验证码"
        placeholder="请输入验证码"
        :rules="[{ required: true, message: '请输入验证码' }]"
      >
        <template #button>
          <sms-btn :phone="phone"></sms-btn>
        </template>
      </van-field>
      <div style="margin:0 16px;margin-bottom:36.5px;">
        <van-checkbox
          v-model="checked"
          shape="square"
          checked-color="#1677FF"
          icon-size="16px"
          style="font-size:12px;height:44px;"
          >
          我已阅读并同意《用户协议》
        </van-checkbox>
        <van-button
          type="info"
          color="#1677FF"
          size="large"
          native-type="submit"
          class="submit-btn"
          >
          立即注册
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import smsBtn from '@/components/smsBtn.vue'
export default {
  name: 'Home',
  components: {
    smsBtn
  },
  data() {
    return {
      username: '',
      pwd:'',
      confirmPwd: '',
      phone: '',
      smscode: '',
      checked: false,
    }
  },
  mounted() {
  },
  methods: {
    onSubmit() {
      if (this.pwd===this.confirmPwd) {
        if (this.checked){
          let params = {
            "souid": 2, // 1-pc 2-wechat
            "mobile": this.phone,
            "uname": this.username,
            "pwd": this.pwd,
            "smscode": this.smscode,
          }
          this.$loading('提交中...')
          this.$http.post(this.$api.userRegister, params).then(res => {
            this.$clear()
            if (res.code==='000') {
              this.$toast('注册成功')
              this.$router.replace({
                path: '/'
              })
            } else {
              this.$toast(res.msg)
            }
          })
        } else {
          this.$toast('请先阅读并同意《用户协议》')
        }
      } else {
        this.$toast('两次密码不一致')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.register{
  .get-code{
    width:80px;
    height:30px;
    background:rgba(255,255,255,1);
    border-radius:3px;
    border:1px solid rgba(37,138,55,1);
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(37,138,55,1);
  }
}
</style>